import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { Button, ButtonProps, Grid, units } from '@ha/dsl';

const useStyles = makeStyles((theme: Theme) => ({
  calendarFooterContainer: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: units.rem(1),
    },
  },
}));

interface Props {
  buttonProps: ButtonProps;
  clearDatesButton?: string;
  overlayCloseButton: string;
  noEndDateButton: string;
  onClearDates?: () => void;
  onNoEndDate: () => void;
  onOverlayClose: () => void;
  showOverlayCloseButton: boolean;
  showNoEndDateButton: boolean;
}

const CalendarFooter: React.FC<Props> = props => {
  const {
    buttonProps,
    clearDatesButton = '',
    onClearDates,
    onNoEndDate,
    onOverlayClose,
    overlayCloseButton,
    noEndDateButton,
    showOverlayCloseButton,
    showNoEndDateButton,
  } = props;

  const { calendarFooterContainer } = useStyles();

  return (
    <Grid
      container
      data-test-locator="DatePicker / CalendarFooter"
      justify="flex-end"
      spacing={1}
      className={calendarFooterContainer}
    >
      {onClearDates && (
        <Grid item>
          <Button
            color="primary"
            variant="outlined"
            {...buttonProps}
            onClick={onClearDates}
          >
            {clearDatesButton}
          </Button>
        </Grid>
      )}
      {showOverlayCloseButton && !showNoEndDateButton && (
        <Grid item>
          <Button
            color="primary"
            variant="contained"
            {...buttonProps}
            onClick={onOverlayClose}
          >
            {overlayCloseButton}
          </Button>
        </Grid>
      )}
      {showNoEndDateButton && (
        <Grid item>
          <Button
            color="primary"
            variant="contained"
            {...buttonProps}
            onClick={onNoEndDate}
          >
            {noEndDateButton}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default React.memo(CalendarFooter);
